export const CHAT_SET_SEARCH_TERM = 'chat@set-search-term';
export const CHAT_SET_INITIALIZING = 'chat@set-initializing';
export const CHAT_RESET_LOADED_STATE = 'chat@chat-reset-loaded-state';
export const CHAT_SET_INIT_DATA = 'chat@set-init-data';
export const CHAT_SET_ERROR = 'chat@set-error';
export const CHAT_SET_ACTIVE_CHAT = 'chat@set-active-chat';
export const CHAT_PREPARE_CHANNEL_TO_PUSH = 'chat@prepare-channel-to-push';
export const CHAT_SET_CHANNELS = 'chat@set-channels';
export const CHAT_PUSH_CHANNEL = 'chat@push-channel';
export const CHAT_PUSH_MESSAGE = 'chat@push-message';
export const CHAT_UPDATE_MESSAGE = 'chat@update-message';
export const CHAT_DELETE_MESSAGE = 'chat@delete-message';
export const CHAT_FETCH_MESSAGES_PAGE = 'chat@fetch-page-of-messages';
export const CHAT_SET_NOW_LOADING_MESSAGES_PAGE = 'chat@set-now-loading-page-of-messages';
export const CHAT_SET_MESSAGES_PAGE = 'chat@set-page-of-messages';
export const CHAT_OPEN_NEW_CHAT = 'chat@open-new-chat';
export const CHAT_SET_PAGE = 'chat@set-chat-page';
export const CHAT_SET_PAGE_CONTENT_HEIGHT = 'chat@set-chat-page-content-height';
export const CHAT_SET_SCROLL_BOTTOM = 'chat@set-chat-page-scroll-bottom';
export const CHAT_MARK_MESSAGE_AS_READ = 'chat@mark-message-as-read';
export const CHAT_SET_FORM_REPLY_TO = 'chat@set-form-reply-to';
